<div class="policy-category disabled">

  <div class="policy-item">
    <i class="policy-number">1</i>
    <div class="default-text large" [innerHTML]="textCopy.contraventionsTitle"></div>
    <div class="default-text" [innerHTML]="textCopy.contraventionsText"></div>
    <contraventions-question [valuesSelected]="contraventionsQuestion.valuesSelected"
                             [options]="contraventionsQuestion.options"
                             (selectAnswer)="onContraventionsQuestionSelected($event)"
                             [active]="contraventionsQuestion.active"></contraventions-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">2</i>
    <radio-question [data]="maximumTime.data" [active]="maximumTime.active"
                    [valueSelected]="maximumTime.valueSelected"
                    (selectAnswer)="onMaximumTimeSelected($event)"></radio-question>
  </div>

  <br />
  <div class="submit-layer">
    <input aria-label=""  type="submit" class="app-submit" value="Save"
           (click)="submitPolicyCategory()" />
  </div>

</div>
